export default __webpack_public_path__ + "images/4164fbd49434debd66ed7963cf9d3976.svg";